import React, { useEffect } from 'react';
import { NVInput } from 'components/generals/inputs/nv__input';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { contactFormSchema } from 'schemas/contact.form.schema';
import { ContactFormInterface } from 'interfaces/contact.form.interface';
import { useSendFormData } from 'reduxStore/services/mailing.services';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import config from 'config';

export default function ContactForm() {
    const { sendFormData, isLoading, error, isSuccess, reset: resetMailing } = useSendFormData();
    const { t } = useTranslation();
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<ContactFormInterface>({
        resolver: yupResolver(contactFormSchema),
        shouldFocusError: false,
    });

    useEffect(() => {
        console.log("CONFIG::: ", config);
    }, []);

    // Efecto para manejar el estado de la respuesta
    useEffect(() => {
        if (isSuccess) {
            reset();
            message.success('Mensaje enviado correctamente', 3);
            resetMailing(); // Limpiar el estado del mailing después de un tiempo
        }
    }, [isSuccess, reset, resetMailing]);

    useEffect(() => {
        if (error) {
            message.error(`Error al enviar el mensaje: ${error}`, 5);
        }
    }, [error]);

    const onSubmit: SubmitHandler<ContactFormInterface> = async (data) => {
        console.log(data);

        const formData = {
            folder: config.EMAIL_FOLDER as string,
            templateHTML: config.EMAIL_TEMPLATE as string,
            fromEmail: config.EMAIL_FROM_SEND as string,
            ToEmail: config.EMAIL_TO_SEND as string,
            subject: 'Nuevo Correo del sitio Web RootsToken',
            name: data.name,
            email: data.email,
            phone: data.phone,
            origen: 'RootsToken.com',
            attachments: [
                {
                    filename: 'logo.png',
                    cid: 'logo@cid',
                },
            ],
        };

        try {
            await sendFormData(formData);
            // El manejo del éxito se hace en el useEffect
        } catch (error) {
            console.error('Error sending form:', error);
            // El manejo del error se hace en el useEffect
        }
    };

    return (
        <main className="nv__contact__form">
            <div className="contact__form__base__container">
                <div className="contact__form__fields">
                    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                        <NVInput
                            name="name"
                            type="text"
                            placeholder={'Nombre'}
                            control={control}
                            className=""
                            errorMessage={errors.name?.message}
                        />
                        
                        <NVInput
                            name="email"
                            type="text"
                            placeholder={'Correo'}
                            control={control}
                            className=""
                            errorMessage={errors.email?.message}
                        />
                        
                        <NVInput
                            name="phone"
                            type="text"
                            placeholder={'Teléfono'}
                            control={control}
                            className=""
                            errorMessage={errors.phone?.message}
                        />

                        <input 
                            type="submit" 
                            value={isLoading ? 'Enviando...' : 'Enviar'} 
                            disabled={isLoading}
                            style={{ 
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer'
                            }}
                        />
                    </form>
                </div>
            </div>
        </main>
    );
}

// Versión alternativa más simple sin el hook personalizado
/*
import { simpleSendFormData } from 'reduxStore/services/mailing.services';

export default function ContactForm() {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<ContactFormInterface>({
        resolver: yupResolver(contactFormSchema),
        shouldFocusError: false,
    });

    const onSubmit: SubmitHandler<ContactFormInterface> = async (data) => {
        setIsLoading(true);
        
        const formData = {
            folder: config.EMAIL_FOLDER as string,
            templateHTML: config.EMAIL_TEMPLATE as string,
            fromEmail: config.EMAIL_FROM_SEND as string,
            ToEmail: config.EMAIL_TO_SEND as string,
            subject: 'Nuevo Correo del sitio Web RootsToken',
            name: data.name,
            email: data.email,
            phone: data.phone,
            origen: 'RootsToken.com',
            attachments: [
                {
                    filename: 'logo.png',
                    cid: 'logo@cid',
                },
            ],
        };

        try {
            const success = await simpleSendFormData(formData);
            
            if (success) {
                reset();
                message.success('Mensaje enviado correctamente', 3);
            } else {
                message.error('Error al enviar el mensaje', 5);
            }
        } catch (error) {
            console.error('Error sending form:', error);
            message.error('Error al enviar el mensaje', 5);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <main className="nv__contact__form">
            <div className="contact__form__base__container">
                <div className="contact__form__fields">
                    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                        <NVInput
                            name="name"
                            type="text"
                            placeholder={'Nombre'}
                            control={control}
                            className=""
                            errorMessage={errors.name?.message}
                        />
                        
                        <NVInput
                            name="email"
                            type="text"
                            placeholder={'Correo'}
                            control={control}
                            className=""
                            errorMessage={errors.email?.message}
                        />
                        
                        <NVInput
                            name="phone"
                            type="text"
                            placeholder={'Teléfono'}
                            control={control}
                            className=""
                            errorMessage={errors.phone?.message}
                        />

                        <input 
                            type="submit" 
                            value={isLoading ? 'Enviando...' : 'Enviar'} 
                            disabled={isLoading}
                            style={{ 
                                opacity: isLoading ? 0.6 : 1,
                                cursor: isLoading ? 'not-allowed' : 'pointer'
                            }}
                        />
                    </form>
                </div>
            </div>
        </main>
    );
}
*/